import React from "react";

const Modal = ({ isCorrect, result, nombreTab, uniteTab, onClickModal }) => {
  const titre = isCorrect
    ? "Bravo ! Tu as la bonne réponse"
    : "Désolé ! Ce n'est pas la bonne réponse";
  function chaine() {
    let returnString = "";
    for (let i = 0; i < nombreTab.length; i++) {
      if (nombreTab[i] === 1 && uniteTab[i]) {
        let unite = uniteTab[i].split(" ");
        unite[0] = unite[0].slice(0, -1);

        unite = unite.join(" ");
        returnString = `${returnString}${nombreTab[i]} ${unite} `;
      } else {
        returnString = `${returnString}${nombreTab[i]} ${uniteTab[i]} `;
      }
    }
    return returnString.toLowerCase();
  }
  function spacingNumber(number) {
    if (!isNaN(number)) {
      var stringArray = number.toString();
      var tab = stringArray.split(".");
      tab[0] = tab[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return tab.join(".");
    } else {
      return "";
    }
  }
  const message = isCorrect
    ? `${chaine()} est égale à ${spacingNumber(result)}`
    : `${chaine()} n'est pas égale à ${spacingNumber(result)}`;
  return (
    <div className="fixed w-full h-full bg-slate-900/30  backdrop-blur-sm left-0 top-0 flex justify-center items-center">
      <div
        className={
          isCorrect
            ? "h-64 w-96 border-4 border-solid border-slate-500 rounded-lg bg-emerald-400"
            : "h-64 w-96 border-4 border-solid border-slate-500 rounded-lg bg-red-400"
        }
      >
        <h1 className="text-lg py-4 self-start w-full border-b-4 border-slate-500 font-bold">
          {titre}
        </h1>
        <p className="text-sd p-4">{message}</p>
        <button
          onClick={onClickModal}
          className="rounded bg-slate-100 p-3 text-black font-bold my-8 border-slate-900 hover:border-2"
        >
          {isCorrect ? "fermer" : "Recommencer"}
        </button>
      </div>
    </div>
  );
};

export default Modal;
